import React from 'react'
import Login from '../../components/common/Login/Login'

const SupplierLogin = () => {
  return (
    <div>
      <Login role='supplier' />
    </div>
  )
}

export default SupplierLogin
